import { render, staticRenderFns } from "./NewPageModal.vue?vue&type=template&id=05f49a1a"
import script from "./NewPageModal.vue?vue&type=script&lang=ts"
export * from "./NewPageModal.vue?vue&type=script&lang=ts"
import style0 from "./NewPageModal.vue?vue&type=style&index=0&id=05f49a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports